import {
    FETCH_MANAGE_PROBABILITY_TYPE,
    LIST_MANAGE_PROBABILITY_TYPE
} from "./types";

const init = {
    isLoading: false,
    list: []
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MANAGE_PROBABILITY_TYPE:
            return {
                ...state,
                isLoading: true
            };
        case LIST_MANAGE_PROBABILITY_TYPE:
            return {
                ...state,
                isLoading: false,
                list: payload.data
            };
        default:
            return state;
    }
}
